module.exports = __webpack_public_path__ + "static/media/HubitaMobile.2ed37fb8.png";